export const initialState = {
  loading: false,
  pl: null,
  response: { message: null, error: null, result: null },
};
